import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { FIELD_TYPES } from 'common/hooks/useForm'
import { maskFuntions } from 'src/features/price-policies/constants'

export async function getAllConventionalBonifications({
    carlotSelected = [],
    stateFilters=[]
}) {
    let query = ''

    stateFilters.forEach((filter)=> {
        if(filter.type === FIELD_TYPES.SELECT){
            query = query + `${filter.keyBackend}[]=${filter.value}&`
        } else {
            query = query + `${filter.keyBackend}=${maskFuntions.removeMask(filter.value)}&`
        }
    })

    carlotSelected.forEach(carLot => {
        query = query + `car_lot_id[]=${carLot}&`
    })

    query = query.slice(0, -1)
    const response = await axios(
        `${REACT_APP_API}/bonifications/conventional/model?${query}`
    )

    return response?.data?.data || []
}
